// import 'bootstrap'
import './sass/main.scss';

require('./js/custom-aos.js');

require('./img/card.png');
require('./img/favicon.png');
